import { render, staticRenderFns } from "./ClinicAppointment.vue?vue&type=template&id=7614c40e"
import script from "./ClinicAppointment.vue?vue&type=script&lang=js"
export * from "./ClinicAppointment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports